import { NavLink, useNavigate } from 'react-router-dom'
import { Icon } from '@carrent/ui'
import { useAuthStore } from '@carrent/core'
import { authApi } from '@carrent/api'
import { NAV_GROUPS } from './navGroups'
import { useChatUnread } from '../hooks/useChatUnread'

export function Sidebar({ collapsed, onToggle, onNavigate }) {
  const chatUnread = useChatUnread()

  const { user, logout } = useAuthStore()
  const navigate = useNavigate()

  const handleLogout = async () => {
    try {
      await authApi.logout()
    } catch {
      // Выход не должен зависеть от доступности сети.
    }
    logout()
    navigate('/login', { replace: true })
  }

  return (
    <aside className="sidebar" aria-label="Основная навигация">
      <div className="sidebar__brand">
        <Icon name="car" size={22} className="sidebar__brand-icon" />
        <span className="sidebar__brand-text">CarRent</span>
        <button
          type="button"
          className="sidebar__toggle"
          onClick={onToggle}
          aria-label={collapsed ? 'Развернуть меню' : 'Свернуть меню'}
          aria-expanded={!collapsed}
        >
          <Icon name={collapsed ? 'chevronRight' : 'chevronLeft'} size={16} />
        </button>
      </div>

      <nav className="sidebar__nav">
        {NAV_GROUPS.map((group) => (
          <div key={group.id} className="sidebar__group">
            <div className="sidebar__group-label">{group.label}</div>
            {group.items.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                onClick={onNavigate}
                className={({ isActive }) => `sidebar__item ${isActive ? 'is-active' : ''}`}
                title={collapsed ? item.label : undefined}
              >
                <Icon name={item.icon} size={18} className="sidebar__item-icon" />
                <span className="sidebar__item-label">{item.label}</span>
                {item.to === '/admin/chats' && chatUnread > 0 && (
                  <span className="sidebar__badge">{chatUnread > 99 ? '99+' : chatUnread}</span>
                )}
              </NavLink>
            ))}
          </div>
        ))}
      </nav>

      <div className="sidebar__footer">
        <div className="sidebar__user">
          <span className="sidebar__user-name">{user?.full_name || user?.phone}</span>
          <span className="sidebar__user-role">{user?.role}</span>
        </div>
        <button type="button" className="sidebar__item sidebar__logout" onClick={handleLogout}>
          <Icon name="logout" size={18} className="sidebar__item-icon" />
          <span className="sidebar__item-label">Выйти</span>
        </button>
      </div>
    </aside>
  )
}
